<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
    <div class="row" [innerHTML]="data.message"></div>

    <div class="row" *ngIf="data.addRemark">
        <br />Tambahkan Catatan (Opsional):
    </div>
    <div class="row" *ngIf="data.addRemark">
        <mat-form-field class="example-full-width" appearance="outline">
            <textarea matInput [(ngModel)]="note" placeholder="Opsional"></textarea>
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close *ngIf="data.isConfirmation">
        Batal
    </button>
    <button mat-raised-button cdkFocusInitial *ngIf="data.isConfirmation" (click)="confirm()" color="primary">
        {{ data.okLabel || 'Lanjut' }}
    </button>
    <button mat-raised-button cdkFocusInitial *ngIf="!data.isConfirmation" (click)="confirm()" color="primary">
        OK
    </button>
</div>